module.exports = __webpack_public_path__ + "static/media/iconPenLastStepHorizontalDone.183d6cbc.svg";